import { render } from "./SystemSettingsStatus.vue?vue&type=template&id=4caad8ca&ts=true"
import script from "./SystemSettingsStatus.vue?vue&type=script&lang=ts"
export * from "./SystemSettingsStatus.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__